import { IPDFTableHeader } from "src/Pages/components/PDF/TableHeader";
import { PDFTableHeader } from "src/Pages/components/PDF/TableHeader/PDFTableHeader";

export const HeadReportProductionGerente = () => {
  const dataHeaderPDF: IPDFTableHeader = [
    {
      style: {
        width: "30%",
        textAlign: "left",
        paddingLeft: "8px",
      },
      title: "Gerente",
    },
    {
      style: {
        width: "30%",
        textAlign: "right",
      },
      title: "Mensalidade",
    },
    {
      style: {
        width: "20%",
        textAlign: "center",
      },
      title: "Contratos",
    },
    {
      style: {
        width: "20%",
        textAlign: "center",
      },
      title: "Vidas",
    },
  ];

  return <PDFTableHeader data={dataHeaderPDF} />;
};
